import { render } from "./PerformanceCard.vue?vue&type=template&id=55bd4f1c"
import script from "./PerformanceCard.vue?vue&type=script&lang=js"
export * from "./PerformanceCard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./PerformanceCard.vue?vue&type=style&index=0&id=55bd4f1c&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__